<template>
  <div class="table-wrapper">
    <div v-if="isLoading" class="is-loading">
      <VsLoader :visible="isLoading" />
    </div>
    <table v-else class="table vs-table is-bordered" :class="{ 'is-hoverable': options.hover }">
      <thead>
        <tr>
          <th v-for="(col, i) in columns" :key="i" :width="col.width" :class="{ 'align-left': options.alignLeft }">
            <span v-if="col.label">{{ col.label | t }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(record, i) in dataArray" :key="i">
          <td v-for="(col, y) in columns" :key="y" :class="{ 'align-left': options.alignLeft }">
            <slot
              v-if="col.custom"
              :colValue="{
                // to be able to change value from parent component
                colInfo: col,
                data: record,
              }"
            />
            <template v-else>
              {{ displayValue(record, col.key, col.filter) }}
            </template>
          </td>
          <slot name="custom" />
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  props: {
    columns: {
      type: Array,
      required: true,
    },
    dataArray: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
    },
    options: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    displayValue(record, key, filter) {
      if (!filter || !this.$options.filters[filter.filterName]) {
        return _.get(record, key);
      }
      return this.$options.filters[filter.filterName](_.get(record, key), filter.params);
    },
  },
};
</script>

<style scoped lang="scss">
.is-loading {
  position: relative;
  width: 100%;
  height: 200px;
  border: 1px solid $gray-300;

  .vs-loader {
    background-color: white;
  }
}

.table-wrapper {
  max-width: 100%;
  margin-bottom: 0 !important;
  overflow-x: auto;
}

.vs-table {
  min-width: 100%;
  font-size: 10px;
  table-layout: fixed;

  thead {
    th {
      height: 40px;
      font-weight: 600;
      font-size: 10px;
      text-align: right;
      vertical-align: middle;
    }
  }

  tbody {
    tr {
      &:hover {
        background-color: #ccf0ed !important;
      }
    }

    td {
      height: 40px;
      font-size: 10px;
      text-align: right;
      vertical-align: middle;
    }
  }
}

.align-left {
  text-align: left !important;
}
</style>
